import { configRefs } from '@utils/config';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';
import { opgavekompleksetTaskSchema } from '../schemas/opgavekomplekset/tasks/_task-data.js';

async function fetchOpgavekompleksetTasks(descriptors) {
  const url = `${await configRefs.apis.opgavekomplekset.get()}/api/player/tasks`;
  const res = await fetch(...authenticateComponentFrameworkRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      sequences: descriptors.map(descriptor => ({
        type: Array.isArray(descriptor) || descriptor.type === "task" ? "tasks" : "folders",
        ids: Array.isArray(descriptor) ? descriptor.map(it => it.id) : descriptor.type === "task" ? [descriptor.id] : [{
          id: descriptor.id,
          taskCount: descriptor.tasks
        }]
      }))
    })
  }));
  if (res.status < 200 || res.status >= 300) {
    const descriptorIds = descriptors.flatMap(descriptor => Array.isArray(descriptor) ? descriptor.map(it => it.id) : [descriptor.id]);
    throw new Error(`fetchOpgavekompleksetTasks(): Failed to fetch tasks for descriptors: ${descriptorIds.join(", ")}\n\n${await res.text()}`);
  }
  const tasks = await res.json();
  return tasks.map(it => opgavekompleksetTaskSchema.parse(it));
}

export { fetchOpgavekompleksetTasks };
//# sourceMappingURL=request.fetch-opgavekomplekset-tasks.js.map
